export type StreamTierId = 'tier1' | 'tier2' | 'tier3';

export interface StreamTier {
  id: StreamTierId;
  name: string;
  delayLabel: string;
  packageId?: string;
}

export type PackageStreamTier = StreamTier & { packageId: string };

export const streamTiers: Record<StreamTierId, StreamTier> = {
  tier1: {
    id: 'tier1',
    name: 'Tier 1',
    delayLabel: 'No delay',
    packageId: '01M4GDGT4A5JKSXCRADSH9GJBE',
  },
  tier2: {
    id: 'tier2',
    name: 'Tier 2',
    delayLabel: '2s delay',
    packageId: '01M4TZZ1SNSPSJ1661P2T45X51',
  },
  tier3: {
    id: 'tier3',
    name: 'Tier 3',
    delayLabel: '5s delay',
  },
};

const hasPackage = (tier: StreamTier): tier is PackageStreamTier =>
  tier.packageId !== undefined;

export const packageStreamTiers: readonly PackageStreamTier[] = [
  streamTiers.tier1,
  streamTiers.tier2,
].filter(hasPackage);

export const findStreamTierByPackageId = (packageId: string) =>
  packageStreamTiers.find((tier) => tier.packageId === packageId);
